import { render, staticRenderFns } from "./zixun3.vue?vue&type=template&id=666f87ce&scoped=true&"
import script from "./zixun3.vue?vue&type=script&lang=js&"
export * from "./zixun3.vue?vue&type=script&lang=js&"
import style0 from "./zixun3.vue?vue&type=style&index=0&id=666f87ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f87ce",
  null
  
)

export default component.exports